import React from 'react';
import { Link } from 'react-router-dom';
import HsyLogo from '../../Assets/Images/hsky-logo.png';

export const Navbar2 = () => (
    <div>
        <header>
            <div className="container">
                <div className="row">
                    <div className="col-6">
                        <div className="logoDiv">
                            <Link to="/"><img src={HsyLogo} alt="logo" /></Link>
                        </div>
                    </div>
                    <div className="col-6">
                        <div className="navigationBar">
                            <ul>
                                <li><Link to="Blogpage">Blogs</Link></li>
                            </ul>
                        </div>
                    </div>
                </div>
            </div>
        </header>
    </div>
);

export default Navbar2;
